import './styles.css';

export const Loading = () => {
    return(
        <div className='loading-container' >
           <div class="loader"></div>
        </div>
    )
}
